__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/9afb206c22666bb4369ecd9c6048d3907d1efac66b005803e007f547/";